// extracted by mini-css-extract-plugin
export default {"root":"SearchQuickActionBar_root__fBOJu","wrapper":"SearchQuickActionBar_wrapper__8Uwke"};